/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    maquileroIdSelected:0,
    defaultDataMaquilero:{}
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_MAQUILERO_ID = 'SET_MAQUILERO_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setMaquileroId = (payload) => ({
  type: SET_MAQUILERO_ID,
  payload,
})
export const setDefaultDataMaquilero = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_MAQUILERO_ID:
        return {
          ...state,
          maquileroIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataMaquilero: payload,
          }
     default:
       return state
   }
 }
 